import React from 'react';
import { observer } from 'mobx-react';

import { AuctionFinalsList } from 'components/AuctionFinals/components';

import BaseStep from '../components/BaseStep';

@observer
class AwardAllStep2 extends BaseStep {
  componentDidMount() {
    const { store, onValidChanged } = this.props;
    onValidChanged(store.auctionFinalsStore.selectedCount > 0);
    store.auctionFinalsStore.onSelectionChanged = this.handleSelectionChanged;
  }

  componentWillUnmount() {
    const { store } = this.props;
    store.auctionFinalsStore.onSelectionChanged = null;
  }

  handleSelectionChanged = (selection) => {
    const { store, onValidChanged } = this.props;
    onValidChanged(store.auctionFinalsStore.selectedCount > 0);
  };

  render() {
    const { store } = this.props;
    const { sale } = store.auctionFinalsStore;

    return (
      <AuctionFinalsList
        sale={sale}
        store={store.auctionFinalsStore}
        locale={sale.saleEdit.locale}
        currency={sale.saleEdit.currencyCode}
        style={{ width: '100%' }}
      />
    );
  }
}

export default AwardAllStep2;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/AwardAll/Step2.jsx